<template>
    <div class="own-business">
        <div class="own-business__wrapper">
            <a class="logout__wrapper" @click="logout()">
                <div class="logout-icon"><i class="fas fa-long-arrow-alt-left"></i></div>
                <div class="logout-text">{{translate('Logout')}}</div>
            </a>
            <div class="logo">
                <a @click="homePage">
                    <img src="@/assets/landing/logo.svg" alt="AirVote Logo">
                </a>
            </div>
            <div class="profile-photo">
                <router-link :to="{name: 'ProfileSettings'}">
                    <img v-if="userInfo.photo_url" :src="userInfo.photo_url" alt="Profile photo">
                    <img v-else src="@/assets/profile.jpg" alt="Profile photo">
                </router-link>
            </div>
        </div>
        <div class="own-business__title">
            {{translate('own_Title')}}
        </div>
        <div class="bussiness-site">
            <div class="bussiness-site__wrapper">
                <QR_SmileysMail :settings="QR_SmileysMailSettings"
                                v-if="this.flow == 'start_question'"></QR_SmileysMail>
                <SelectBusinessFlow :settings="selectBusinessFlowSettings"
                                    v-if="this.flow == 'about_business'"></SelectBusinessFlow>
            </div>
        </div>
        <div class="language-change">
            <ul class="language-list">
                <li class="language-icon" @click="$ml.change(lang)"
                    :key="lang"
                    :style="{backgroundImage: 'url(' + require('@/assets/' + lang + '.png') + ')'}"
                    v-for="(lang) in $ml.list"></li>
            </ul>
        </div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
    </div>


</template>

<script>
    // Import plugins
    import Autocomplete from 'v-autocomplete'

    import 'v-autocomplete/dist/v-autocomplete.css'
    // Import components
    import logAnalyticsEvent, {logPageView} from '@/helpers/analytics'
    import mapMixin from '@/mixins/mapMixin';
    import config from '@/api/config';
    import errorMixin from '@/mixins/errorMixin';
    import questionMixin from '@/mixins/questionMixin';
    import customModalDialog from '@/components/widgets/customModalDialog';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import SelectBusinessFlow from "./selectBusinessFlow";
    import QR_SmileysMail from "./QR_SmileysMail";

    export default {
        name: 'mainLayout',

        mixins: [mapMixin, errorMixin, questionMixin],

        components: {
            QR_SmileysMail,
            SelectBusinessFlow,
            customModalDialog,
            Autocomplete,
        },

        data() {
            return {
                skipClose: false,
                customModalSettings: {},
                selectBusinessFlowSettings: {
                    onOkHandler: this.onSiteSelectionCompleted,
                    businessFlow: true,
                    siteFlow: true,
                    addressFlow: true,
                    siteSelectorFlow: false,
                    haveSiteQuestion: false,
                    subtitle: this.translate('own_Subitle'),
                },
                QR_SmileysMailSettings: {
                    pdf_uid: '',
                },
                succesStatusURI: 'registered',
                flow: 'about_business',
                welcomeModal: true,
                isActive: false,
                langSelect: this.$ml.current,
                placeResponse: null,
                placeSearch: '',
            }
        },

        computed: {
            ...mapGetters({
                isUserAdmin: 'auth/isUserAdmin',
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                hasOwnOrganization: 'auth/hasOwnOrganization',
                hasOwnPlace: 'auth/hasOwnPlace',
                ownPlaces: 'auth/ownPlaces',
                getOwnPlace: 'auth/getOwnPlace',
                siteManagerPlaces: 'auth/siteManagerPlaces',
                isAddSite: 'organization/isAddSite',
                hasOrgManagerPlace: 'auth/hasOrgManagerPlace',
                orgManagerPlaces: 'auth/orgManagerPlaces',
            }),
            ...mapState({
                accessToken: state => state.auth.accessToken,
                makeOwnerBool: state => state.owner.makeOwnerBool,
                userInfo: state => state.auth.userInfo
            }),

        },

        watch: {
            isAddSite(val) {
                this.showMapModal = val
            },
            showMapModal(val) { //bool
                if (!val) {
                    this.rates = []
                }
            }
        },

        methods: {
            ...mapActions({
                searchPlaceAutocomplete: 'search/searchPlaceAutocomplete',
                updateQuestion: 'question/updateQuestion',
                fetchPlace: 'place/fetchPlace',
                createPlaceAction: 'place/createPlace',
                connectOwnerToPlace: 'place/connectOwnerToPlace',
                connectQuestionToPlaceAdmin: 'question/connectQuestionToPlaceAdmin',
                connectQuestionToManager: 'question/connectQuestionToManager',
                fetchUserInfo: 'auth/fetchUserInfo',
                addSite: 'owner/addSite',
                fetchSelectedStartTemplates: 'question/fetchSelectedStartTemplates',
                connectSelectedStartTemplates: 'question/connectSelectedStartTemplates',
                clearSelectedStartTemplates: 'question/clearSelectedStartTemplates',
                updateProfileLang: 'profiles/updateProfileLang',
                logoutRemote: 'auth/logout',
                setMultipleSitesModeAction: 'organization/setMultipleSitesMode',
            }),

            ...mapMutations({
                setLanguage: 'setLanguage',
                removeKeys: 'auth/removeKeys',
            }),

            businessFlowDone() {
                this.$store.commit('owner/setOwner', false)
                this.clearUnlinkedQuestion()
            },

            async setupLocationForNewQuestion(payload) {
                const body = {
                    text: payload.input.value,
                    optional: payload.additionalInputs[0].value
                };
                try {
                    const response = await this.updateQuestion({
                        questionId: payload.questionUid,
                        body
                    })
                    if (response.success) {
                        this.customModalSettings = {
                            message: this.translate('Success'),
                            icon: 'ic_allow.svg',
                        }
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },
            async logout() {
                logAnalyticsEvent('drawer_logout_click')
                try {
                    await this.logoutRemote()
                } catch (error) {
                    console.log('error', error)
                } finally {
                    this.removeKeys()
                    this.$store.commit('owner/setOwner', false)
                    this.$router.push('/sign-in')
                }
            },

            onSiteSelectionCompleted(siteItem) {
                console.log(siteItem)
                if (siteItem.place_tz == null) {
                    try {
                        siteItem.place_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
                    } catch (e) {
                    }
                }
                if (this.getUnlinkedQuestion() && this.isUserAdmin) {
                    this.connectQuestionToPlaceForAdmin(siteItem)
                } else {
                    this.connectPlaceForClient(siteItem)
                }
            },

            async connectQuestionToPlaceForAdmin(site) {
                try {
                    await this.connectQuestionToPlaceAdmin({
                        questionId: this.getUnlinkedQuestion().id,
                        body: site
                    })
                    this.customModalSettings = {
                        message: this.translate('bflow_AddQuestionSuccess'),
                        icon: 'ic_allow.svg',
                        questionUid: this.getUnlinkedQuestion().id,
                        sectionClass: 'leftAlign',
                        input: {
                            label: this.translate('Question'),
                            value: this.getUnlinkedQuestion().value,
                            disabled: true
                        },
                        additionalInputs: [
                            {
                                label: this.translate('Location'),
                                value: this.getUnlinkedQuestion().location
                            },
                        ],
                        showCancelButton: true,
                        okButtonText: this.translate('Save'),
                        onOkHandler: this.setupLocationForNewQuestion,
                        cancelButtonText: this.translate('OK'),
                        onCancelHandler: this.businessFlowDone
                    }
                    this.businessFlowDone()
                    this.$router.push({name: 'adminPanel'})
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

            async connectPlaceForClient(site) {
                logAnalyticsEvent(`own_business_scrn_approve_own_place`)
                try {
                    let response = await this.connectOwnerToPlace(site)
                    await this.fetchUserInfo()
                    let selectedTemplates = await this.fetchSelectedStartTemplates()
                    if ((selectedTemplates.collection && selectedTemplates.collection.length > 0)
                    || (selectedTemplates.text_items && selectedTemplates.text_items.length > 0)) {
                        let connected = await this.connectSelectedStartTemplates({siteUid: response.guid})
                        localStorage.removeItem('login_questions')
                        let clear = await this.clearSelectedStartTemplates()
                        this.flow = 'start_question'
                        this.QR_SmileysMailSettings.pdf_uid = connected.pdf_uid
                    }
                    logAnalyticsEvent(`signup_business_finish`)
                    this.businessFlowDone()
                    if (this.flow == 'about_business') {
                        this.$router.push({name: 'OwnerPlaceManagementStatus', params: {status: this.succesStatusURI}})
                    } else {
                        logPageView('Business flow with questions finished', '', `/dashboard/registered`)
                        logAnalyticsEvent(`owner_dashboard_registered_q`)
                        logAnalyticsEvent('CompleteRegistration', null, true)
                    }
                } catch (e) {
                    logAnalyticsEvent(`signup_business_error`)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

            homePage() {
                window.open(`${config.siteUrl}/${this.$ml.current}`, '_blank').focus()
            },

            changelang() {
                logAnalyticsEvent('lang_click', {
                    lang: this.$ml.current,
                    source: this.$route.name === 'Login' ? 'sign_in' : 'drawer'
                })
                this.langShow = !this.langShow
                this.langSelect = this.$ml.current;
                this.setLanguage(this.$ml.current)
                this.updateLanguage()
            },
            async updateLanguage() {
                const response = await this.updateProfileLang(localStorage.getItem('lang'))
            },

        },

        mounted() {
            this.fetchUserInfo().then(() => {
                console.log(`this.isUserOwner:${this.isUserOwner} this.hasOwnPlace:${this.hasOwnPlace} this.hasOrgManagerPlace:${this.hasOrgManagerPlace} this.isUserSiteManager:${this.isUserSiteManager} this.getUnlinkedQuestion():${this.getUnlinkedQuestion()}`)
                if (((this.isUserOwner && this.hasOwnPlace) || (this.hasOrgManagerPlace && this.orgManagerPlaces.length > 1) || (this.isUserSiteManager)) && this.getUnlinkedQuestion()) {
                    this.$store.commit('owner/setOwner', false)
                    this.$router.push({name: 'OwnerPlaceManagement'})
                }
            })
            if (localStorage.getItem('login_questions') !== null) {
                this.selectBusinessFlowSettings.haveSiteQuestion = true
            }
            console.log(this.selectBusinessFlowSettings.haveSiteQuestion)
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {

                if (to.matched.some(record => record.meta.requiresAuth)) {
                    console.log(!vm.accessToken)
                    if (!vm.accessToken) {
                        vm.$router.push({name: 'Login'})
                    }
                } else if (vm.makeOwnerBool == false) {
                    vm.$router.push({name: 'Login'})
                }
            })
        }
    }
</script>

<style>

    own-business. {
        width: 100%;
    }

    .own-business .vue-map-container {
        position: relative;
        display: block;
    }

    .bussiness-site {
        display: flex;
        justify-content: center;
        margin-top: 36px;
    }

    .bussiness-site__wrapper {
        border-radius: 4px;
        background-color: #FFFFFF;
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.12);
    }


    .own-business .v-autocomplete-input {
        height: 54px;
        border-bottom: 2px solid #3F405C;
        font-size: 20px;
        font-weight: 700;
        width: 290px;
        outline: none;
        border-radius: 1px;

    }


    .own-business .v-autocomplete .v-autocomplete-list {
        max-height: 250px;
        overflow-y: auto;
        background: #fff;
        text-align: left;
        width: 100%;
    }

    .own-business__wrapper {
        display: flex;
        justify-content: space-between;
        position: relative;
        margin-top: 40px;
        margin-left: 50px;
        margin-right: 80px;
    }

    .own-business__title {
        text-align: center;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 48px;
        margin-top: 27px;
    }


    .language-change {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .language-icon {
        background-size: contain;
        height: 31px;
        width: 31px;
        cursor: pointer;
    }

    .logo {
        cursor: pointer;
    }

    .logout__wrapper {
        display: flex;
        cursor: pointer;
    }

    .logout-icon {
        margin-right: 7px;
    }

    .logout-text {
        color: #3F405C;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 19px;
    }

    .contact-link a {
        font-weight: 500;
        color: #ffbf00;
    }

    .contact-link a:hover {
        text-decoration: none;
        outline: none;
        color: #ffbf00;
    }

    @media screen and (max-width: 820px) {
        .bussiness-site__wrapper {
            margin-left: 15px;
            margin-right: 15px;
        }
    }

    @media screen and (max-width: 426px) {
        .bussiness-site__wrapper {
            box-shadow: none;
            -webkit-box-shadow: none;
        }

        .logout__wrapper {
            top: 25px;
            left: 30px;
        }

        .logo {
            width: 75px;
        }

        .own-business__wrapper {
            margin-left: 15px;
            margin-right: 50px;
        }

        .own-business__title {
            line-height: 35px;
            margin-top: 15px;
            font-size: 32px;
        }
    }

    @media screen and (max-width: 376px) {
        .logout__wrapper {
            top: 25px;
            left: 20px;
        }

        .own-business__title {
            font-size: 30px;
        }
    }

    @media screen and (max-width: 321px) {
        .logout__wrapper {
            top: 25px;
            left: 15px;
        }
    }
</style>
<style scoped>
    .profile-photo {
        height: 40px;
        width: 40px;
        border-radius: 5px;
    }

    .profile-photo img {
        border-radius: 50%;
    }
</style>

